import { render, staticRenderFns } from "./RealtimeLeadsDashboard.vue?vue&type=template&id=a6fa4266&scoped=true"
import script from "./RealtimeLeadsDashboard.vue?vue&type=script&lang=js"
export * from "./RealtimeLeadsDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6fa4266",
  null
  
)

export default component.exports